import * as Yup from 'yup';

export const validationSchema = Yup.object({
  name: Yup.string().required('Template name is required').max(50, 'Template name must be less than 50 characters'),
  constructionType: Yup.object({
    label: Yup.string(),
    value: Yup.string(),
  })
    .required('Construction Type is required')
    .nullable(),
  projectType: Yup.object({
    label: Yup.string(),
    value: Yup.string(),
  })
    .required('Project Type is required')
    .nullable(),
  description: Yup.string().max(250, 'Description cannot be greater than 250 characters.').nullable(),
});
